<template>
 <div class="mt-3 templete-reference">
    <h5 class="font-weight-bold">Please make your Cheques payable to HealthServe Ltd</h5>
    <div class=" flex">
      <div class="first-area">
        
        <p class="mb-1" style="font-size: 1.1em">Our mailing address:</p>
        <p style="font-size: 1.1em" class="mb-0">HealthServe Limited, 1 Lorong 23 Geylang #01-07, Building 4, Singapore, 388352</p>
      </div>
        <div class="second-area">
              <div class="bg-hs-pastel-crimson p-3">
              <h5 style="margin-bottom: 3px; font-weight: bold; font-size: 16px; line-height: 24px;">Your reference number </h5>
              <code>{{checkout.Reference}}</code>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
    name:"cheque",
    props:{
        checkout: Object
    }
}
</script>

<style>

</style>